import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import {authenticated} from '../../apis/api';

class PrivateRouteWithLayout extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            isAuthenticated: false,
        };
    }

    componentDidMount() {
        this.checkLogin();
    }

    componentWillReceiveProps() {
        this.checkLogin();
    }

    checkLogin() {
        authenticated()
            .then((res) => {
                this.setState({
                    loading: false,
                    isAuthenticated: process.env.NODE_ENV === 'development' ? true : res.isLogin,
                });
            });
    }

    render() {
        const {layout: Layout, component: Component, ...rest} = this.props;

        return (
            <Route
                {...rest}
                render={
                    props => this.state.isAuthenticated ? (
                        <Layout>
                            <Component {...props}/>
                        </Layout>
                    ) :
                    this.state.loading ? null : <Redirect to="/sign-in" />
                }
            />
        );
    }
}

PrivateRouteWithLayout.propTypes = {
    component: PropTypes.any.isRequired,
    layout: PropTypes.any.isRequired,
    path: PropTypes.string,
    title: PropTypes.string
};

export default PrivateRouteWithLayout;
